import { create } from 'zustand';
import { StaffingPartnerList } from '@libs/models/staffingPartners';
import { fetchStaffingPartnersList } from '@libs/api/staffingPartners/fetch';
import { FiltersCollection } from '@libs/store/filters';
import { SPECIAL_AGENCIES } from '@libs/config';

type InitialState = {
  loadingList: boolean;
  staffingPartners: StaffingPartnerList[];
  loadStaffingPartners: (filters: FiltersCollection) => Promise<void>;
};

export const useStaffingPartnersList = create<InitialState>()((set) => ({
  loadingList: false,
  staffingPartners: [],
  loadStaffingPartners: async (filters) => {
    set({ loadingList: true });
    try {
      const resp = await fetchStaffingPartnersList({ filters });
      const { items } = resp;

      const shiftnexIndex = items.findIndex((item) => item.id === SPECIAL_AGENCIES.ShiftnexMarketplace);
      if (shiftnexIndex !== -1) {
        // Move Shiftnex Marketplace to the top of the list
        const shiftnex = items.splice(shiftnexIndex, 1)[0];
        shiftnex.contractType = '1099';
        shiftnex.contractorName = 'ShiftnexMarketplace';
        items.unshift(shiftnex);
      }
      const actrivIndex = items.findIndex((item) => item.id === SPECIAL_AGENCIES.Actriv);
      if (actrivIndex !== -1) {
        // Move Actriv to the second position in the list
        const actriv = items.splice(actrivIndex, 1)[0];
        actriv.contractType = 'W2';
        actriv.contractorName = 'Actriv';
        items.splice(1, 0, actriv);
      }
      set({
        loadingList: false,
        staffingPartners: items,
      });
    } finally {
      set({ loadingList: false });
    }
  },
}));
